import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryScanRunArgs } from "types/generated";

import { ScanRunDetailItem } from "./types";

type GetScanRunData = {
  scanRun: ScanRunDetailItem;
};

export const GET_SCAN_RUN: TypedDocumentNode<GetScanRunData, QueryScanRunArgs> = gql`
  query GetScanRun($id: ID!) {
    scanRun(id: $id) {
      id
      createdAt
      note
      state
      stateChangedAt
      resourceCount
      resourceStats {
        managed
        unmanaged
      }
      scan {
        id
        name
        space {
          id
        }
      }
    }
  }
`;
